import { useIntl } from 'react-intl'
import theme from 'theme_'

import { homeDeviceInformationMessages as messages } from '../../messages'
import DeviceInformationCard from '../../components/DeviceInformationCard'
import { DeviceStatusColorProps } from '../types'

function YellowStatus({ statusString }: DeviceStatusColorProps) {
  const { formatMessage } = useIntl()

  return (
    <DeviceInformationCard
      title={formatMessage(messages.deviceConnectionStatusLabel)}
      value={statusString || formatMessage(messages.deviceStatusCardWarnings)}
      color={theme.colors.statusYellow}
      bgColor={theme.colors.lightYellow}
      order={1}
    />
  )
}

export default YellowStatus
